import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Luxe Looks Kenya';
const DEFAULT_DESCRIPTION = 'Your trusted online beauty store. Shop premium skincare, makeup, fragrances, hair and more — delivered across Kenya.';
const DEFAULT_IMAGE = '/logo192.png';
const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://luxelooks.co.ke';

export default function SEO({
  title,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  url,
  type = 'website',
  noindex = false,
  canonical
}) {
  const fullTitle = title
    ? `${title} | ${SITE_NAME}`
    : `Luxe Looks Kenya | Your Trusted Online Beauty Store`;
  const fullUrl = url
    ? `${SITE_URL}${url}`
    : SITE_URL;
  const fullImage = image.startsWith('http')
    ? image
    : `${SITE_URL}${image}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {canonical && <link rel="canonical" href={canonical} />}

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
    </Helmet>
  );
}
